import { render, staticRenderFns } from "./ClicToolbar.vue?vue&type=template&id=524770e5&scoped=true&"
import script from "./ClicToolbar.vue?vue&type=script&lang=js&"
export * from "./ClicToolbar.vue?vue&type=script&lang=js&"
import style0 from "./ClicToolbar.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ClicToolbar.vue?vue&type=style&index=1&id=524770e5&lang=scss&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524770e5",
  null
  
)

export default component.exports